@use '../../../../../../../styles/Constants.scss' as Constants;
@use '../../../../../../../styles/Colors.scss' as Colors;

$shift-container-gap: 136px;

.container {
	position: relative;
}

.shift {
	display: flex;
	justify-content: flex-start;
	gap: $shift-container-gap;
	align-items: center;
	padding: Constants.$val-spacing-m 0;
}